import Icon from '../components/Icon.vue'

Icon.register({
  hotel: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M560 64h-16v384h16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-240v-80c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v80h-240c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h16v-384h-16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h544c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM256 108.8v38.4c0 6.4 6.4 12.8 12.8 12.8h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8zM256 204.8v38.4c0 6.4 6.4 12.8 12.8 12.8h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8zM128 108.8v38.4c0 6.4 6.4 12.8 12.8 12.8h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8zM179.2 256c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8h38.4zM192 384h192c0-53-43-96-96-96s-96 43-96 96zM448 243.2v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8h38.4c6.4 0 12.8-6.4 12.8-12.8zM448 147.2v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8h38.4c6.4 0 12.8-6.4 12.8-12.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hotel.js
// module id = 1467
// module chunks = 0